import { useShopAllowedCountries } from './use-shop-allowed-countries'

interface UseShopCountryAccess {
  checkIfCompanyHasShopAccess: (countryCode: string | undefined) => boolean
}

/**
 * Hook to determine if a country has access to the web shop
 */
export const useShopCountryAccess = (): UseShopCountryAccess => {
  const [allowedCountries] = useShopAllowedCountries()

  const checkIfCompanyHasShopAccess = (countryCode: string | undefined): boolean => {
    let result = false

    if (allowedCountries.find(country => country.code === countryCode)) {
      result = true
    }

    return result
  }

  return { checkIfCompanyHasShopAccess }
}
